export const API_ENDPOINTS = {
  POST_BOOKING_FORM: "/bookings",
  HOTELS: "/hotels",
  SERVICES: "/services",
  SEASON_PERIOD: "/configurations/public/season-period",
};
